import { ArgumentError } from '../utils/errors';

import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class StepModel extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, widgetId }) {
        if (!organizationId || !widgetId) {
            throw new ArgumentError(`[Model][Step][getAll] organizationId and widgetId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/widgets/${widgetId}/steps`; //setRoute here
    }
}
